import { render, staticRenderFns } from "./RubinDocumentListing.vue?vue&type=template&id=14c973ac&scoped=true"
import script from "./RubinDocumentListing.vue?vue&type=script&lang=js"
export * from "./RubinDocumentListing.vue?vue&type=script&lang=js"
import style0 from "./RubinDocumentListing.vue?vue&type=style&index=0&id=14c973ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c973ac",
  null
  
)

export default component.exports